//use if whole page can't load (e.g. fetch failed)

import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { errorContainer, errorTitle } from "../../styles/errorStyles";

const ErrorMessage = ({ error }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box sx={errorContainer(theme)} role="alert" aria-live="assertive">
      <Typography sx={errorTitle} aria-describedby="error-text">
        {t("error")}
      </Typography>
      <Typography id="error-text" sx={errorTitle}>
        {typeof error === "string" ? error : error?.message || t("errors.generic")}
      </Typography>
    </Box>
  );
};

export default ErrorMessage;
